<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Tests",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            loading: true,
            title: "Tests",
            items: [
               {
                  text: "Tests",
                  active: true,
               },                   
            ],

            
            labs: [
               {
                  id: null,
                  lab_name: "Lab 1"
               },
               {
                  id: null,
                  lab_name: "Lab 2"
               },
               {
                  id: null,
                  lab_name: "Lab 3"
               },
               {
                  id: null,
                  lab_name: "Lab 4"
               },
            ],

            test: {
               id: null,
               name: "",
               description: "",
               type: "",
               prize: "",
               lab_id: 0,

            },
            test_type: "",
            tests: [],
            test_name: 0,
            test_status: {
               id: "",
               status: "",
            },

            lab: [],
            all_tests: [],
            assigned_tests: [],

            file_image: "",
            file_preview_image: "",

            lab_id: 0,           
            lab_keyword: '',
            lab_visible: false,
            
            modal_title: "Add Test",
            button_title: "Save",
            pagination: {},
            edit: false,

            type: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            selectedTest: "",
            

            from: "",
            to: "",
            total: "",

            delete: false,
            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();
      },


      created(){
         this.fetchTests();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchTests(page_url = null){

            this.getToken();

            let url = "api/admin/lab/test/assign-details?lab_id=" + this.$route.params.id + " &limit=" + this.listing_length + "&status=" + this.type + "&search=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);

               // Use responseData.lab and responseData.bookings_count
               this.lab = responseData.lab;
					this.all_tests = responseData.all_tests;
               this.assigned_tests = responseData.assigned_tests.data;
               this.from = responseData.assigned_tests.from;
               this.to = responseData.assigned_tests.to;
               this.total = responseData.assigned_tests.total;
               this.pagination = responseData.assigned_tests.links;



            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));







         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         assignTest(){

            this.getToken();
            this.loading = true;

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/test/assign";
            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id);
            this.tests.forEach((test) => {
                  formData.append("test_ids[]", test.id);
            });
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                      this.fetchTests();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs.tests' });

                  this.clearForm();
                  this.hideModal('test-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

   

         },


         updateTest(){


            this.getToken();
            this.loading = true;

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/test/assign-update";
            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id);
            formData.append("id", this.test.id);
            formData.append("price", this.test.prize);
            formData.append("type", this.test.type);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs.tests' });


                  this.clearForm();
                  this.hideModal('update-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

               
               this.fetchTests();



         },

         activateTest(test) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this test?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.test_status.id = test.id;
                  this.test_status.status = 1;
                  this.updateTestStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateTest(test) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this test?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.test_status.id = test.id;
                  this.test_status.status = 2;
                  this.updateTestStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },

         updateTestStatus(){


            this.getToken();

            const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            };

            let url = "api/admin/lab/test/assign-unpublish";
            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id);
            formData.append("id", this.test_status.id);
            formData.append("status", this.test_status.status);
            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs.tests' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
            this.fetchTests();
         },


         uploadFile(){
            this.getToken();
            const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            };

            let url = "api/admin/lab/importTest";
            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id);
            formData.append("file", this.file_image);
            this.loading = true;

            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     // this.hideModal('test-modal2');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  // this.$router.push({ name: 'labs.tests' });
                  this.hideModal('test-modal2');
                  this.fetchTests();

               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
            // this.fetchTests();
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 


         closeLabSearch() {
            this.lab_visible = false;        
            this.lab_keyword = '';
         },

         
         setLab() {
            this.lab_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.lab_visible = false;
         },

         
         fetchLabs() {  
            this.lab_visible = true;   
         },
         showModal(modal) {
            this.$refs[modal].show();
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },
         editTest(assigned_test) {
            
            this.edit = true;

            // if (!assigned_test.price) {
            // this.test.prize = 'Rs.';
            // } else {
            // this.test.prize = 'Rs.' + assigned_test.price;
            // }           
            this.test.prize = assigned_test.price;
            this.test.id = assigned_test.id;
            if (assigned_test.type) {
            this.test.type = assigned_test.type;
            } else {
            this.test.type = '';
            }

            this.errors = {};
            this.modal_title = "Edit Test";
            this.button_title = "Update";
            this.test_type = "0";
            this.lab_keyword = '';
            this.lab_visible = false;
            this.labs = [];

            this.showModal("update-modal");
         },
         addTest() {
            if (this.selectedTest !== '') {
            let text = this.all_tests.find((test) => test.id === this.selectedTest).name;

            // Check if the test with the same id already exists in the 'tests' array.
            let exists = this.tests.some((test) => test.id === this.selectedTest);

            if (!exists) {
               this.tests.push({ id: this.selectedTest, title: text });
            }
            }

            // Reset the selectedTest value
            this.selectedTest = '';
         },
          removeTest(index) {
              this.tests.splice(index, 1);
          }, 


         formatDate(dateString) {
            const date = new Date(dateString);

            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();

            const hours = date.getHours();
            const minutes = date.getMinutes();

            return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
         },


         clearForm() {
            this.edit = false;
            this.test.id = null;
            this.test.title = "";
            this.test.description = "";
            this.test.name = "";
            this.test.prize = "";
            this.test.lab_id = 0;
            this.lab_keyword = '';
            this.modal_title = "Add Test";
            this.button_title = "Save";
            this.errors = {};
            this.test_name ="";
            this.lab_id = 0;
            this.test_type = "0";
            this.errors = {}; 
            this.errors.test_ids = [];
            this.selectedTest = "";
            this.tests = [];
            this.test_status= {};
            this.file_image  = "";
         },
         setFile(e) {
            this.file_image = e.target.files[0];
            this.file_preview_image = URL.createObjectURL(e.target.files[0]);
         },
         
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'labs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">{{ lab.name }}</h5>
                              <p>
                                 {{ lab.address }}<br>
                                 {{ lab.mobile }}
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 
                  <div class="row mb-4">
                     <div class="col-12">
                        <b-button v-b-modal.test-modal variant="primary" class="float-end me-2">Add Test</b-button>
                        <b-button v-b-modal.test-modal2 variant="primary" class="float-end me-2">Upload</b-button>
                     </div>
                  </div>

                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchTests()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"  @keyup="fetchTests()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="type"  @change="fetchTests()">
                              <option value="">All</option>
                              <option value="1">Published</option>
                              <option value="2">Unpublished</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

      <thead class="table-light">
         <tr>
            <th width="10%">Name</th>  
            <th width="15%">Description</th> 
            <th width="10%">Price</th> 
            <th width="8%">Type</th> 
            <th width="10%">Created On</th>
            <th width="20%">Options</th>
         </tr>
      </thead>

      <tbody v-if="Boolean(assigned_tests.length)">
         <tr v-for="(assigned_test) in assigned_tests" :key="assigned_test.id">
            <td>{{ assigned_test.name }}</td>
            <td>{{ assigned_test.description }}</td>
            <td>Rs.{{ assigned_test.price }}</td>
            <td><span v-if="assigned_test.type === 1">Lab</span>
            <span v-else-if="assigned_test.type === 2">Home</span>
            <span v-else-if="assigned_test.type === 3">Both</span></td>
            <td>{{ formatDate(assigned_test.created_at) }}</td>
            <td>
               <!-- <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editTest()">Edit</b-button> -->
               <!-- <b-button v-if="assigned_test.status === 1" variant="danger" class="btn-sm me-2 mb-2" @click="testUnpublish(assigned_test)" >Unpublish</b-button> -->

               <b-button v-if="assigned_test.status === 1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateTest(assigned_test)">Unpublish</b-button>

               <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateTest(assigned_test)">Publish</b-button>
                
               <b-button variant="primary" v-b-modal.update-modal class="btn btn-sm me-2 mb-2" @click="editTest(assigned_test)">Update</b-button> 

            </td>
         </tr>
      </tbody>
      <tbody v-else>
         <tr>
            <td colspan="5" class="text-center">No tests found</td>
         </tr>
      </tbody>

</table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(assigned_tests.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTests(page.url + '&lab_id='+ $route.params.id + '&limit='+ listing_length + '&status=' + type + '&search=' + keyword)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                     
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="test-modal" id="test-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent = "assignTest">
                        <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Test name <span class="text-danger">*</span></label>
                                       <select class="form-control" @change="addTest()" v-model="selectedTest" v-bind:class="{ 'is-invalid': Boolean(errors.test_ids && errors.test_ids.length > 0) }">
                                          <option value="" >Select</option>
                                          <option :value="all_test.id" v-for="all_test in all_tests" :key="all_test.id">
                                          {{ all_test.name }}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.test_ids" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(test, index) in tests" :key="index">
                                             <p>{{ test.title }}<span @click="removeTest(index)" class="text-danger"  v-bind:class="{ 'is-invalid': Boolean(errors.test_ids) }"><i class="fas fa-times-circle"></i></span></p>
                                             <div v-for="(val, index) in errors.test_ids" :key="index" class="invalid-feedback">
                                                <p class="mb-0">{{ val }}</p>
                                             </div>
                                       </div>
                                    
                                    </div>

                                 </div>
                       
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{ loading ? 'Saving...' : button_title }}
                           </b-button>
                           <b-button class="" variant="light" @click="hideModal('test-modal')" :disabled="loading">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                   <!---- modal starts ---->
                   <b-modal ref="test-modal2" id="test-modal2" title="Upload File" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent = "uploadFile">
                        <div class="row">
                                    <div class="form-group col-12"> 
                                       <label>File <span class="text-danger">*</span> <span class="small">[Allowed formats: .xlsx,.xls]</span></label>

                                             <input type="file" @change="setFile($event)" accept=".xlsx,.xls" class="form-control" :class="{ 'is-invalid': Boolean(errors.file) }" />
                                             <!-- <img v-if="proof_preview_image" class="avatar-sm mt-2" :src="proof_preview_image"> -->

                                             <div v-for="(val, index) in errors.file" :key="index" class="invalid-feedback">
                                                <p class="mb-0">{{ val }}</p>
                                             </div>

                                          </div>
                                 </div>
                       
                        <b-col md="12">
                           <!-- <b-button type="submit" class="me-3" variant="primary">Upload</b-button>
                           <b-button class="" variant="light" @click="hideModal('test-modal2')">Close</b-button> -->
                           <div class="page-loader" v-if="!loading">
                              <b-button type="submit" class="me-3" variant="primary">Upload </b-button>
                              
                              <b-button class="" variant="light" @click="hideModal('tvshow-modal')">Close</b-button>
                           </div> 

                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->
                  <b-modal ref="update-modal" id="update-modal" title="Update Price" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent = "updateTest">
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Price <span class="text-danger">*</span></label>
                           <b-input-group>
                              <b-input-group-prepend>
                                 <b-input-group-text>Rs</b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input v-model="test.prize" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.price) }"></b-form-input>
                              <div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                           </b-input-group>

                        </b-col>
                        <b-col md="12" class="form-group">
                           <label>Test Type <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="test.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                           <option value="">Select</option>
                           <option value="1">Lab</option>
                           <option value="2">Home</option>
                           <option value="3">Both</option>
                           </select>
                           <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{ loading ? 'Updating...' : button_title }}
                           </b-button>
                           <b-button class="" variant="light" @click="hideModal('update-modal')" :disabled="loading">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
